export enum FisheryMapMode {
  STATIC = "STATIC",
  NEW_FISHERY = "NEW_FISHERY",
  ADD_NEW_FISHERY = "ADD_NEW_FISHERY",
  EDIT_FISHERY = "EDIT_FISHERY",
}
